import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export const sidebar: SxProps<Theme> = {
  display: { xs: "none", md: "flex" },
  flexDirection: "column",
  gap: 0.5,
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 2.5,
  boxShadow: 1,
  p: 1.75,
  position: "sticky",
  top: 84,
};

export const tabItem =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    px: 1.75,
    py: 1.5,
    borderRadius: 1.5,
    cursor: "pointer",
    fontSize: "0.8125rem",
    fontWeight: 600,
    color: active ? "primary.main" : "text.secondary",
    bgcolor: active ? alpha(theme.palette.primary.main, 0.1) : "transparent",
    transition: "all 0.2s ease",
    border: "none",
    fontFamily: theme.typography.fontFamily,
    textAlign: "start",
    width: "100%",
    "&:hover": {
      bgcolor: active ? alpha(theme.palette.primary.main, 0.1) : alpha(theme.palette.action.hover, 0.08),
    },
  });

export const tabLabel: SxProps<Theme> = {
  flex: 1,
  textAlign: "start",
};

export const sidebarDivider: SxProps<Theme> = {
  my: 1,
  mx: 0.5,
};

export const roleFooter: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  gap: 1,
  px: 1.25,
  py: 1,
};

export const roleIconWrap: SxProps<Theme> = (theme) => ({
  width: 30,
  height: 30,
  borderRadius: 1.125,
  bgcolor: alpha(theme.palette.primary.main, 0.1),
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flex: "none",
});

export const roleTextBlock: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
};

export const roleTitle: SxProps<Theme> = {
  fontSize: "0.71875rem",
  fontWeight: 700,
};

export const roleSubtitle: SxProps<Theme> = {
  fontSize: "0.625rem",
  color: "text.secondary",
};
